import type { ReactNode } from 'react';

export function FieldLabel({ children }: { readonly children: ReactNode }) {
  return <span className="text-ctx-content-title ts-subtitle-xxs">{children}</span>;
}
